// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"765a1cbf","396":"aa28a69c","455":"3cad1f5a","977":"6a571447"}[chunkId] + ".chunk.js";
};